import {useQuery} from "@tanstack/react-query";
import api from "../../utils/api.ts";
import {useContext, useEffect} from "react";
import MessageContext from "../../context/MessageContext.tsx";
import axios from "axios";

const useSavedItem = (type: SaveItemType, id: string | undefined): SavedState | undefined => {
    const {setLoaderMessage, error: alertError} = useContext(MessageContext);
    const {data, error, isLoading} = useQuery<SavedState>({
        queryFn: async () => {
            const res = await api.get(`/persistence/${type}/${id}`)
            return res.data as SavedState;
        },
        queryKey: ['persistence', type, id],
        enabled: !!id,
        retry: false
    })


    useEffect(() => {
        setLoaderMessage(isLoading ? 'Loading data...' : '');
    }, [isLoading])


    useEffect(() => {
        if (error && axios.isAxiosError(error) && error.response) {
            alertError('Error', error.response.data.error);
        }
    }, [error])
    return data;
}

export default useSavedItem;
